import React, { useState } from 'react';
import { S } from './ControlsTableRemoveButton.styles';
import { RemoveControlDialog } from '../RemoveControlDialog';
import * as AlertDialog from '@radix-ui/react-alert-dialog';

type Props = {
  controlId: string;
  inspectionId: string;
};

export const ControlsTableRemoveButton: React.FC<Props> = (props) => {
  const [openAlert, setOpenAlert] = useState(false);

  return (
    <AlertDialog.Root open={openAlert} onOpenChange={setOpenAlert}>
      <AlertDialog.Trigger asChild>
        <S.ActionButton
          type="button"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setOpenAlert(true);
          }}
        >
          <S.Icon src="Trash" width={24} height={24} color="error" />

          <S.B2 $top="xs" $color="error" $weight={500}>
            Ta bort kontroll
          </S.B2>
        </S.ActionButton>
      </AlertDialog.Trigger>

      <RemoveControlDialog
        onClose={() => setOpenAlert(false)}
        controlId={props.controlId}
        inspectionId={props.inspectionId}
      />
    </AlertDialog.Root>
  );
};
